import { createApi } from "@reduxjs/toolkit/query/react";
import { listCatalogResponse, listCatalogRequest } from "../../types";
import { axiosBaseQuery } from "../../providers/auth0-instance";
import { withErrorNotification } from "../notifications";

const generateUniqueCatalogId = (
  imageType: string,
  specimen_id: string,
  capture_id: string,
): string => {
  if (imageType === "Mesh") {
    return `MESH_${capture_id}`;
  }
  return `SPECIMEN_${specimen_id}`;
};

export const catalogApi = createApi({
  reducerPath: "catalogApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Catalog"],
  refetchOnFocus: true,
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    listCatalog: builder.query<listCatalogResponse, listCatalogRequest>({
      query: (params) => ({
        url: "/catalog",
        method: "GET",
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.items.map(
                ({ imageType, capture, id: specimen_id }) =>
                  ({
                    type: "Catalog",
                    id: generateUniqueCatalogId(
                      imageType,
                      specimen_id,
                      capture._id,
                    ),
                  }) as const,
              ),
              { type: "Catalog", id: "LIST" },
            ]
          : [{ type: "Catalog", id: "LIST" }],
      onQueryStarted: withErrorNotification("Failed to fetch catalog images"),
    }),
    invalidateCatalog: builder.mutation<void, void>({
      queryFn: () => ({ data: undefined }),
      invalidatesTags: ["Catalog"],
    }),
  }),
});

export const {
  useListCatalogQuery,
  usePrefetch,
  useInvalidateCatalogMutation,
} = catalogApi;
